export function hasPadding(style?: Record<string, any>) {
  return !!(style?.padding || style?.paddingBottom || style?.paddingLeft || style?.paddingTop || style?.paddingRight)
}

export function toDimensionValue(value: number | string | undefined, defaultValue?: string): string {
  if (value === undefined) return defaultValue || 'auto'
  if (typeof value === 'number') return `${value}px`
  if (/^[\d.]+(%|px|em|rem|vh|vw|vmin|vmax)$/.test(value)) return value
  if (/^\d+$/.test(value)) return `${value}px`
  return value
}
